<template>
    <div>
        <card-list title="Unit List" dataUrl="/api/v1/unit" dataSize="10"
                   :dataHeaders="tHeaders" editRoute="/master/unit/add"
                   deleteEndpoint="/api/v1/unit"
        />
    </div>
</template>
<script>
    import CardList from "../../components/CardList";
    export default {
        components: {
            CardList,
        },
        data() {
            return {
                tHeaders: [
                    {id: 'ID', align: 'center'},
                    {unit: 'Unit', align: 'left'},
                ]
            }
        }
    }
</script>
